import React from 'react'
import styled from 'styled-components'

const Footer = () => {
    const ListFooter = styled.div`
        display: flex;
        justify-content: space-around;
        padding: 20px 0;
        width: 100%;
        font-size: 90%;
        a {
            color: #424242;
        }
    `

    return (
        <ListFooter>
            <a href="http://Salveat.com/misc">A propos</a>
            <a href="http://Salveat.com/misc">Conditions</a>
            <a href="http://Salveat.com/misc">Contact</a>
        </ListFooter>
    )
}

export default Footer
